module.exports = __webpack_public_path__ + "img/colored_ouija.7fa45029.png";